var React = require('react');

function ProjectType (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#eeeef4","d":"M40.34 44.63L19.89 32.82V.25l20.45 11.81v32.57z","key":0}),React.createElement("path",{"fill":"#a4c2ea","d":"M34 50.03L10.76 36.61V2.76L34 16.19v33.84z","key":1}),React.createElement("path",{"fill":"#679de8","d":"M18.66 28.08l-4.07-2.35v-4.41l4.07 2.35v4.41z","key":2}),React.createElement("path",{"fill":"#fff","d":"M18.66 18.47l-4.07-2.35V11.7l4.07 2.35v4.42zM29.77 22.27a.54.54 0 01-.25-.06l-7.39-4.31a.5.5 0 01.5-.87L30 21.34a.51.51 0 01.18.69.49.49 0 01-.41.24z","key":3}),React.createElement("path",{"d":"M29.77 32a.45.45 0 01-.25-.07l-7.39-4.31a.5.5 0 11.5-.86L30 31.09a.5.5 0 01-.25.93z","fill":"#679de8","key":4})]);
}

ProjectType.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 50 50"};

module.exports = ProjectType;

ProjectType.default = ProjectType;
